// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file environment_info/natgw.proto (package environment_info, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message environment_info.NatGwRequest
 */
export type NatGwRequest = {
/**
 * @generated from field: environment_info.UserContext user_context = 1;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message environment_info.NatGwResponse
 */
export type NatGwResponse = {
/**
 * @generated from field: repeated string public_ips = 1;
 */
publicIps?: string[];
}
;
/**
 * @generated from message environment_info.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from message environment_info.EnvIdRequest
 */
export type EnvIdRequest = {
}
;
/**
 * @generated from message environment_info.EnvIdResponse
 */
export type EnvIdResponse = {
/**
 * @generated from field: string env_id = 1;
 */
envId?: string;
}
;
/**
 * @generated from rpc environment_info.NatGwService.GetNatGwIps
 */
export const NatGwService_GetNatGwIps = new RPC<NatGwRequest,NatGwResponse>("POST", "/getNatGWIP");
/**
 * @generated from rpc environment_info.NatGwService.GetEnvId
 */
export const NatGwService_GetEnvId = new RPC<EnvIdRequest,EnvIdResponse>("GET", "/getEnvId");
